
import React from "react";
import Grid from '@mui/material/Unstable_Grid2';
import '../App.css';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Prayers from "./Prayers";
import MediaCard from "./Prayers";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select  from '@mui/material/Select';
import axios from 'axios';
import { useState , useEffect} from "react";
import moment from "moment";
import "moment/dist/locale/ar-dz";

function  MainContent(){

        moment.locale("ar");

        // states 
        const [nextPrayerIndex, setNextPrayerIndex] = useState(2);
        const [remainingTime, setRemainingTime] = useState("");

        const [timings , setTimings] = useState({
            Fajr: "04:11",
            Dhuhr: "12:58",
            Asr: "15:18",
            Sunset: "18:03",
            Isha: "19:33",
        });

        const [selectedCity, setSelectedCity] = useState(
            { 
                displayName: " القاهرة",
                apiName: "Cairo"
            }
            );

        const [today , setToday] = useState("");
        const [timer , setTimer] = useState(10);
    
        const availableCities = [
            { 
                displayName: " القاهرة",
                apiName: "Cairo"
            } ,
            {
                displayName: " الجيزة",
                apiName: "Giza" 
            },
            { 
                displayName: "الاسكندرية",
                apiName: "Alexandria"
            } , 
            { 
                displayName: "سيناء",
                apiName: "Sinai"
            } , 
            { 
                displayName: "سوهاج",
                apiName: "Sohag"
            } , 
            { 
                displayName: "اسيوط",
                apiName: "Assuit"
            } , 
            {
                displayName: "اسوان",
                apiName: "Asuwan",
            }
        ];

        const prayersArray = [
            { key: "Fajr", displayName: "الفجر" },
            { key: "Dhuhr", displayName: "الظهر" },
            { key: "Asr", displayName: "العصر" },
            { key: "Sunset", displayName: "المغرب" },
            { key: "Isha", displayName: "العشاء" },
        ];

        const getTiming = async( ) => {
            const data = await axios.get(`https://api.aladhan.com/v1/timingsByCity?country=EG&city=${selectedCity.apiName}`);
            console.log("the data is" , data.data.data.timings);
            setTimings(data.data.data.timings);
        }

        useEffect(() => {
                getTiming();

        }, [selectedCity] );

        useEffect(() => {
            let interval = setInterval(() => {
                console.log("calling timer");
                setupCountdownTimer();
            }, 1000);
    
            const t = moment();
            // let date = new Date();
            // console.log(date);
            // console.log(date.getHours());

            setToday(t.format('  Do MMMM YYYY , hh : mm a'));
            console.log(t.format('  Do MMMM YYYY , hh : mm a'));
            console.log(t.toString());
            console.log(moment);
            
    
            return () => {
                clearInterval(interval);
            };
        }, [timings]);

    //
    const setupCountdownTimer = () => {
		const momentNow = moment();

		let prayerIndex = 2;

		if (
			momentNow.isAfter(moment(timings["Fajr"], "hh:mm")) &&
			momentNow.isBefore(moment(timings["Dhuhr"], "hh:mm"))
		) {
			prayerIndex = 1;
		} else if (
			momentNow.isAfter(moment(timings["Dhuhr"], "hh:mm")) &&
			momentNow.isBefore(moment(timings["Asr"], "hh:mm"))
		) {
			prayerIndex = 2;
		} else if (
			momentNow.isAfter(moment(timings["Asr"], "hh:mm")) &&
			momentNow.isBefore(moment(timings["Sunset"], "hh:mm"))
		) {
			prayerIndex = 3;
		} else if (
			momentNow.isAfter(moment(timings["Sunset"], "hh:mm")) &&
			momentNow.isBefore(moment(timings["Isha"], "hh:mm"))
		) {
			prayerIndex = 4;
		} else {
			prayerIndex = 0;
		}

		setNextPrayerIndex(prayerIndex);

		// now after knowing what the next prayer is, we can setup the countdown timer by getting the prayer's time
		const nextPrayerObject = prayersArray[prayerIndex];
		const nextPrayerTime = timings[nextPrayerObject.key];
		const nextPrayerTimeMoment = moment(nextPrayerTime, "hh:mm");

		let remainingTime = moment(nextPrayerTime, "hh:mm").diff(momentNow);

		if (remainingTime < 0) {
			const midnightDiff = moment("23:59:59", "hh:mm:ss").diff(momentNow);
			const fajrToMidnightDiff = nextPrayerTimeMoment.diff(
				moment("00:00:00", "hh:mm:ss")
			);

			const totalDiffernce = midnightDiff + fajrToMidnightDiff;

			remainingTime = totalDiffernce;
		}
		console.log(remainingTime);

		const durationRemainingTime = moment.duration(remainingTime);

		setRemainingTime(
			`${durationRemainingTime.seconds()} : ${durationRemainingTime.minutes()} : ${durationRemainingTime.hours()}`
		);
		console.log(
			"duration issss ",
			durationRemainingTime.hours(),
			durationRemainingTime.minutes(),
			durationRemainingTime.seconds()
		);
	};

    //

    const handleCityChange = (event) => {
        const cityObject = availableCities.find((city) => {
            return city.apiName == event.target.value;                   
        });
            console.log("the new value is" , event.target.value);
            setSelectedCity(cityObject);
        };

    return(
            <>
                <Grid container  style={{display:"flex" , justifyContent:"space-around", flexWrap:"wrap" , margin:"30px 10px" }} >
                    <Grid  >
                        <div>
                            <h2> {today} </h2>
                            <h2>  {selectedCity.displayName} </h2>
                        </div>
                    </Grid>

                    <Grid  >
                        <div>
                            <h2>  متبقي حتي صلاة {prayersArray[nextPrayerIndex].displayName} </h2>
                            <h1> {remainingTime} </h1>
                        </div>
                    </Grid>
                </Grid>

                <Divider style={{ borderColor: "white", opacity: "0.6" }} />

                {/* cards */}

                <Stack 
                    // className="cardsHolder"
				    direction="row"
				    justifyContent={"space-around"}
                    flexWrap={"wrap"}
				    style={{ marginTop: "50px" } }
                    >
                        <MediaCard  name="الفجر"  time={timings.Fajr} imagee="https://wepik.com/api/image/ai/9a07baa7-b49b-4f6b-99fb-2d2b908800c2"  />
                        <MediaCard  name="الظهر"  time={timings.Dhuhr}  imagee="https://wepik.com/api/image/ai/9a07bb45-6a42-4145-b6aa-2470408a2921"  />
                        <MediaCard  name="العصر"  time={timings.Asr}  imagee="https://wepik.com/api/image/ai/9a07bb90-1edc-410f-a29a-d260a7751acf"  />
                        <MediaCard  name="المغرب" time={timings.Sunset}  imagee="https://wepik.com/api/image/ai/9a07bbe3-4dd1-43b4-942e-1b2597d4e1b5"  />
                        <MediaCard  name="العشاء" time={timings.Isha}   imagee="https://wepik.com/api/image/ai/9a07bc25-1200-4873-8743-1c370e9eff4d"  />
                </Stack>

                {/* select stack */}

                <Stack direction="row" justifyContent={"center"} style={{marginTop:"40px"}} >
                    <FormControl   style={{width:"40%"}}>
                        <InputLabel id="demo-simple-select-label" style={{color:"white"}} >
                            <span style={{ color: "white" }}>
                                المدينة      
                            </span>  
                        </InputLabel>
                        <Select
                            style={{color:"white"}}
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            // value={age}
                            label="Age"  
                            onChange={handleCityChange}
                        >

                            {availableCities.map((city) => {
                                return (
                                    <MenuItem value={city.apiName} key={city.apiName}>
                                            {city.displayName}
                                    </MenuItem>
                                );

                            })}
                        
                        </Select>
                    </FormControl>

                </Stack>
                

            </>
    );
}

export default MainContent;

